$(window).load(function () {
	if (window.location.hash && window.location.pathname.search("sustainability")) {
	  var target = location.hash.split('#');
	 	$('.section-sustainability page.home').animate({opacity: 0}, 100);	
	  	$('.section-sustainability page.keypoints').css('display', 'block').delay(200).queue(function(){
		    $(this).addClass("active").dequeue();				    
		});	
		$('.section-sustainability page.home').animate({opacity: 0}, 100);	
		  setTimeout(function() {
			$('.section-sustainability .button-scroll[data-parent-id='+target[1]+']').trigger('click');
		  }, 1000);
	}

	
});
$(document).ready(function(){
	$('body#sustainability').on('mousewheel DOMMouseScroll', function(e){
		if(typeof e.originalEvent.detail == 'number' && e.originalEvent.detail !== 0) {
			if(e.originalEvent.detail > 0) {
				$('.section-sustainability page.keypoints').css('display', 'block').delay(200).queue(function(){
				    $(this).addClass("active").dequeue();				    
				});	
				$('.section-sustainability page.home').animate({opacity: 0}, 1000);		
			} else if(e.originalEvent.detail < 0){}
		} else if (typeof e.originalEvent.wheelDelta == 'number') {
			if(e.originalEvent.wheelDelta < 0) {
				$('.section-sustainability page.keypoints').css('display', 'block').delay(200).queue(function(){
				    $(this).addClass("active").dequeue();				    
				});
				$('.section-sustainability page.home').animate({opacity: 0}, 1000);	
			} else if(e.originalEvent.wheelDelta > 0) {}
		}
	});

	$('body#sustainability').on('touchmove', function(e){
        if (e.originalEvent.touches[0].clientY > 0 || e.originalEvent.touches[0].clientY > 0) {
           $('.section-sustainability page.keypoints').css('display', 'block').delay(200).queue(function(){
			    $(this).addClass("active").dequeue();				    
			});
			$('.section-sustainability page.home').animate({opacity: 0}, 1000);	
        }
	    
	});

	$('.section-sustainability .hamburger').click(function() {
		$(this).toggleClass("active");
		$('.section-sustainability .menu').toggleClass("active");
	});	

	$('.section-sustainability .button-scroll').click(function() {
		var refID = $(this).data("parent-id");
		openSection(refID);
	});	

	$('.section-sustainability .button-link').click(function() {
		var refID = $(this).data("parent-id");
		$('.section-sustainability .hamburger').trigger('click');
		$('.subpage-policy .policy-close').trigger('click');
		$('.subpage-mission .mission-close').trigger('click');
		$('.section-sustainability page.home').animate({opacity: 0}, 100);	
	  	$('.section-sustainability page.keypoints').css('display', 'block').delay(200).queue(function(){
		    $(this).addClass("active").dequeue();				    
		});	
		  setTimeout(function() {
			$('.section-sustainability .button-scroll[data-parent-id='+refID+']').trigger('click');
		  }, 1000);
	});	


	$('.section-sustainability .mission-trigger').click(function() {
		$('.section-sustainability .hamburger').trigger('click');
		$('.section-sustainability [data-page="mission-strategy"]').css('display', 'block').delay(200).queue(function(){
			 $('.section-sustainability page.keypoints').removeClass("active");
		    $(this).addClass("active").dequeue();				    
		});	
	});	

	$('.section-sustainability .mission-close').click(function() {
		$('.section-sustainability [data-page="mission-strategy"]').removeClass("active").queue(function(){
			$('.section-sustainability page.keypoints').addClass("active");
		   $('.section-sustainability [data-page="mission-strategy"]').css('display', 'none').delay(1500).dequeue();
		   
		});
	});	

	$('.section-sustainability .policy-trigger').click(function() {
		$('.section-sustainability .hamburger').trigger('click');
		$('.section-sustainability [data-page="our-policy"]').css('display', 'block').delay(200).queue(function(){
			 $('.section-sustainability page.keypoints').removeClass("active");
		    $(this).addClass("active").dequeue();				    
		});	
	});	

	$('.section-sustainability .policy-close').click(function() {
		$('.section-sustainability [data-page="our-policy"]').removeClass("active").queue(function(){
			$('.section-sustainability page.keypoints').addClass("active");
		   $('.section-sustainability [data-page="our-policy"]').css('display', 'none').delay(1500).dequeue();
		   
		});
	});	
	

	$(document).on('click','.section-sustainability section.minimal .article_header',function() {
		var openID = $(this).parent().data("section-id");
		var closeID = $('.section-sustainability section.article.active').data("section-id");
		switchSection(openID,closeID);
	});	

	function openSection(ref){
		var openThis = $('.section-sustainability section.article[data-section-id=' + ref +']');
  		
  		$('.section-sustainability section.article').find('.article_header-content').fadeOut(800, function(){

	  		$('.section-sustainability section.article').not(openThis).each(function(){
	     		$(this).addClass("minimal");     		
	     		$(this).find('.video-holder').fadeOut(1000);					     
			});
			openThis.addClass('active');
			$('.section-sustainability section.article').addClass("disable-hover");  		
			openThis.find('.content').css('display', 'block').delay(400).queue(function(){
			    $(this).animate({ scrollTop: 200 }, 400).dequeue();				    
			});

  		});		
	}

	function switchSection(openID,closeID){
	
	var openThis = $('.section-sustainability section.article[data-section-id=' + openID +']');
		
		/*
		var closeThis = $('.section-sustainability section.article[data-section-id=' + closeID +']');
		closeThis.find('.content').animate({ scrollTop: 0 }, 500, function(){
			$(this).css('display', 'none');
			
			closeThis.find('.video-holder').fadeOut(800, function(){
				
				openThis.addClass('active').removeClass("minimal");
				closeThis.addClass("minimal").removeClass("active").delay(400).queue(function(){
				    openThis.find('.minimal-title').css('display', 'none');
					closeThis.find('.minimal-title').css('display', 'block');
					openThis.find('.video-holder').fadeIn(600, function(){
						openThis.find('.content').css('display', 'block').delay(100).queue(function(){
						    $(this).animate({ scrollTop: 200 }, 400).dequeue();				    
						});
					});
				});
			});
		});		
	*/
	

	$('.section-sustainability section.article').not(openThis).find('.minimal-title').css('display', 'block');
	
	if( $(window).width() < 701 ){
		$('.section-sustainability section.article').not(openThis).css('display', 'none');
		$('.section-sustainability section.article').find('.content').css('display', 'none');
		 openThis.find('.minimal-title').css('display', 'none');
	}


	$('.section-sustainability section.article').not(openThis).find('.content').animate({ scrollTop: 0 }, 500, function(){
		$('.section-sustainability section.article').find('.content').css('display', 'none');
		$('.section-sustainability section.article').not(openThis).find('.video-holder').fadeOut(800, function(){
			openThis.addClass('active').removeClass("minimal");
			
			$('.section-sustainability section.article').not(openThis).addClass("minimal").removeClass("active").delay(400).queue(function(){
			    openThis.find('.minimal-title').css('display', 'none');
			});
			
		});
	});


	 setTimeout(function() {
	 	if( $(window).width() < 701 ){
	 		openThis.find('.content').css('display', 'block').delay(100).queue(function(){
				$('.section-sustainability section.article').not(openThis).css('display', 'flex');
			    $(this).animate({ scrollTop: 200 }, 400).dequeue();				    
			});
	 	}else{
	 		 openThis.find('.video-holder').fadeIn(600, function(){
				openThis.find('.content').css('display', 'block').delay(100).queue(function(){
				    $(this).animate({ scrollTop: 200 }, 400).dequeue();				    
				});
			});
	 	}
	 	    
	  }, 1400);
		

		
					
	}
	
});